import { createContext, useContext } from "react";

const OfferDetailContext = createContext(null);

export const useOfferDetail = () => {
  const ctx = useContext(OfferDetailContext);
  if (!ctx) throw new Error("useOfferDetail must be used within OfferDetailProvider");
  return ctx;
};

export default OfferDetailContext;
